<template>
  <div class="container below" width="90%">
    <v-container class="pt-0 mt-0 ma-0 px-0 mb-10 justify-center" fluid>
      <h1 class="text-center">Вся статистика и анализ в одном сервисе</h1>
      <h2 class="text-center mt-5">
        Universtat - сервис для анализа матчей Mortal Kombat
      </h2>
      <p class="text-center mt-3">
        Доступ к статистике, удобные фильтры и инструменты для поиска закономерностей
      </p>
      <v-row class="justify-center mt-10">
        <v-col class="d-flex justify-center">
          <v-card width="100%" height="100%" class="rounded-xl">
            <v-img
              content-class="d-flex justify-center"
              class="mx-auto"
              height="200"
              width="260"
              contain
              :src="require('../assets/mk_logo.jpeg')"
            ></v-img>
            <v-card-title class="heading justify-center">
              Обширная база матчей Mortal Kombat
            </v-card-title>
            <v-card-text>
              Доступ к базе данных Mortal Kombat – более 500 000 матчей,
              пополняющихся в режиме «online» и доступных для анализа. Сервис
              оснащён удобными фильтрами, позволяющими проводить всесторонний
              анализ: по коэффициентам, персонажам, коридорам времени и интервалам.
            </v-card-text>
          </v-card>
        </v-col>
        <v-col class="d-flex justify-center">
          <v-card width="100%" height="100%" class="rounded-xl">
            <v-img
              class="mx-auto"
              height="200"
              width="260"
              contain
              :src="require('../assets/neural.png')"
            ></v-img>
            <v-card-title class="heading justify-center">
              Инструменты автоматизации
            </v-card-title>
            <v-card-text>
              Наилучшие закономерности, найденные за 8 лет исследований, были
              автоматизированы в виде специальных ботов. Боты оповещают о появлении
              лучших событий, найденных с помощью анализа по множеству критериев.
              Данные инструменты входят в пакеты «аналитик» и «эксперт».
            </v-card-text>
          </v-card>
        </v-col>
        <v-col class="d-flex justify-center">
          <v-card width="100%" height="100%" class="rounded-xl">
            <v-img
              class="mx-auto mt-15 mb-15"
              height="80"
              width="260"
              contain
              :src="require('../assets/education.png')"
            ></v-img>
            <v-card-title class="heading justify-center"
              >Информационная поддержка</v-card-title
            >
            <v-card-text>
              Каждый клиент сервиса имеет возможность связаться со специалистом
              для получения информационной поддержки. В нашем Telegram-канале
              регулярно публикуются полезные материалы, объясняющие, как наиболее
              эффективно работать со статистикой и анализом.
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-divider width="100%"></v-divider>
    <div class="d-flex justify-center pt-10 pb-10">
      <h1>Наши тарифы</h1>
    </div>
    <div class="panel pricing-table d-flex">
      <div class="pricing-plan">
        <img
          src="https://s22.postimg.cc/8mv5gn7w1/paper-plane.png"
          alt=""
          class="pricing-img"
        />
        <h2 class="pricing-header">Базовый</h2>
        <ul class="pricing-features">
          <li class="pricing-features-item">Доступ к статистике</li>
          <li class="pricing-features-item">Инструкция по работе с сервисом</li>
          <li class="pricing-features-item">PDF "Time Code"</li>
          <li class="pricing-features-item">2 бота: "Time Code" и "Time Code 2.0"</li>
          <li class="pricing-features-item">Оптимальный вариант для знакомства с сервисом</li>
          <li class="pricing-features-item">Техническая поддержка</li>
          <li class="pricing-features-item">Срок: 1 месяц</li>
        </ul>
        <span class="pricing-price">{{ min_price }}₽</span>
        <v-dialog
          class="d-flex align-end"
          v-model="dialog"
          max-width="400px"
          content-class="rounded-xl"
        >
          <template v-slot:activator="{ on }">
            <a class="pricing-button" v-on="on" @click="pay('MIN')">Купить</a>
          </template>
          <v-card>
            <v-card-title>Переход к оплате</v-card-title>
            <v-card-text
              >После нажатия кнопки вы будете перенаправлены на страницу
              оплаты</v-card-text
            >
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                class="success ma-4"
                large
                :loading="this.loading"
                :href="this.payment_url"
                @click="dialog = false"
                target="_blank"
              >
                Оплатить
              </v-btn>

              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>

      <div class="pricing-plan">
        <img
          src="https://s28.postimg.cc/ju5bnc3x9/plane.png"
          alt=""
          class="pricing-img"
        />
        <h2 class="pricing-header">Аналитик</h2>
        <ul class="pricing-features">
          <li class="pricing-features-item">Доступ к статистике</li>
          <li class="pricing-features-item">Доступ в закрытый канал "PRO AI"</li>
          <li class="pricing-features-item">Комплект ботов для углублённого анализа</li>
          <li class="pricing-features-item">Методические материалы для продвинутой аналитики</li>
          <li class="pricing-features-item">Оптимальный выбор для перехода на новый уровень</li>
          <li class="pricing-features-item">Доступ в чат с участниками канала</li>
          <li class="pricing-features-item">Срок: 2 месяца</li>
        </ul>
        <span class="pricing-price">
          <span class="pricing-price-old">{{ med_price }}₽</span>
          <span class="pricing-price-new">{{ med_price_sale }}₽</span>
        </span>
        <div class="d-flex justify-center mb-0 pb-0 align-end">
          <v-dialog
            v-model="dialog"
            max-width="400px"
            content-class="rounded-xl"
          >
            <template v-slot:activator="{ on }">
              <a class="pricing-button" v-on="on" @click="pay('MED')">Купить</a>
            </template>
            <v-card>
              <v-card-title>Переход к оплате</v-card-title>
              <v-card-text
                >После нажатия кнопки вы будете перенаправлены на страницу
                оплаты</v-card-text
              >
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  class="success ma-4"
                  large
                  :loading="this.loading"
                  :href="this.payment_url"
                  @click="dialog = false"
                  target="_blank"
                >
                  Оплатить
                </v-btn>

                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
      </div>

      <div class="pricing-plan">
        <img
          src="https://s21.postimg.cc/tpm0cge4n/space-ship.png"
          alt=""
          class="pricing-img"
        />
        <h2 class="pricing-header">Эксперт</h2>
        <ul class="pricing-features">
          <li class="pricing-features-item">Доступ к статистике</li>
          <li class="pricing-features-item">Совместное ведение дневника результатов</li>
          <li class="pricing-features-item">Комплект ботов для максимального анализа</li>
          <li class="pricing-features-item">Продвинутые методики работы с данными</li>
          <li class="pricing-features-item">Все методические материалы проекта</li>
          <li class="pricing-features-item">Безлимитная обратная связь</li>
          <li class="pricing-features-item">Срок: 6 месяцев</li>
        </ul>
        <span class="pricing-price">
          {{ max_price_sale }}₽
        </span>
        <br />

        <v-dialog v-model="dialog" max-width="400px" content-class="rounded-xl">
          <template v-slot:activator="{ on }">
            <a class="pricing-button" v-on="on" @click="pay('MAX')">Купить</a>
          </template>
          <v-card>
            <v-card-title>Переход к оплате</v-card-title>
            <v-card-text
              >После нажатия кнопки вы будете перенаправлены на страницу
              оплаты</v-card-text
            >
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                class="success ma-4"
                large
                :loading="this.loading"
                :href="this.payment_url"
                @click="dialog = false"
                target="_blank"
              >
                Оплатить
              </v-btn>

              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </div>

    <v-divider class="mt-10"></v-divider>
    <div class="d-flex justify-center py-10">
      <v-card width="100%" class="text-center pa-5 rounded-lg elevation-5" style="background: linear-gradient(to right, #f5f7fa, #e4e7eb);">
        <h2 class="text-h4 font-weight-bold primary--text mb-3">📩 Остались вопросы?</h2>
        <p class="text-subtitle-1 mb-5">Все материалы выдаются менеджером в Telegram. Напишите, чтобы начать работать с сервисом!</p>
        <v-btn x-large rounded color="primary" href="https://t.me/univermen" target="_blank" class="px-8 py-2 font-weight-bold elevation-3" style="letter-spacing: 1px; text-transform: none;">Написать в Telegram</v-btn>
      </v-card>
    </div>
    <v-divider class="mt-10"></v-divider>
    <reviews></reviews>
    <v-divider class="mt-10"></v-divider>
    <div class="pt-10">
      <h1 class="d-flex justify-center pb-10">Что вы получите?</h1>
      <v-row>
        <v-col>
          <!-- made by DinosoftLabs -->
          <v-img
            class="mx-auto"
            height="100"
            width="100"
            contain
            :src="require('../assets/stats.png')"
          ></v-img>
          <div class="text-center">
            Достоверную статистику в реальном времени
          </div>
        </v-col>
        <v-col>
          <!-- made by ultimatearm -->
          <v-img
            class="mx-auto"
            height="100"
            width="100"
            contain
            :src="require('../assets/analysis.png')"
          ></v-img>
          <div class="text-center">Подробный анализ матчей</div>
        </v-col>
        <v-col>
          <!-- made by Freepik -->
          <v-img
            class="mx-auto"
            height="100"
            width="100"
            contain
            :src="require('../assets/support.png')"
          ></v-img>
          <div class="text-center">Техническую поддержку</div>
        </v-col>
        <v-col>
          <!-- made by Freepik -->
          <v-img
            class="mx-auto"
            height="100"
            width="100"
            contain
            :src="require('../assets/book.png')"
          ></v-img>
          <div class="text-center">Доступ к информационной базе</div>
        </v-col>
      </v-row>
    </div>
    <v-divider class="mt-10"></v-divider>

    <div id="vk_community_messages"></div>
    <script type="application/javascript">
      VK.Widgets.CommunityMessages("vk_community_messages", 206203830, {
        tooltipButtonText: "Есть вопрос?",
        widgetPosition: "left",
      });
    </script>
  </div>
</template>

<script>
import api from "../config/api";
import Reviews from "./Reviews.vue";
export default {
  components: {
    Reviews,
  },
  data() {
    return {
      loading: false,
      dialog: false,
      payment_url: "",
      min_price: 750,
      min_price_sale: 750,
      med_price: 7999,
      med_price_sale: 4990,
      max_price: 19990,
      max_price_sale: 19990,
    };
  },
  computed: {
    med_price_diff: {
      get() {
        return Math.round(
          ((this.med_price - this.med_price_sale) / this.med_price) * 100,
          2
        );
      },
    },

    max_price_diff: {
      get() {
        return Math.round(
          ((this.max_price - this.max_price_sale) / this.max_price) * 100,
          2
        );
      },
    },
  },
  methods: {
    checkIfCenter(index) {
      return index == 1;
    },

    uuidv4() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          var r = (Math.random() * 16) | 0,
            v = c == "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        }
      );
    },
    async pay(sub_type) {
      let prices = {
        MIN: this.min_price_sale,
        MED: this.med_price_sale,
        MAX: this.max_price_sale,
      };
      let price = prices[sub_type];
      console.log("PRICE: " + price);

      this.loading = true;
      const response = await api({
        url: "/payment/",
        method: "post",
        data: {
          amount: {
            value: price,
            currency: "RUB",
          },
          confirmation: {
            type: "embedded",
          },
          capture: true,
          description: sub_type + " подписка",
          idempotence_key: this.uuidv4(),
        },
      });
      var url = response.data.confirmation;
      this.payment_url = url;
      this.loading = false;
      // window.open(url, "_blank");
    },
  },
};
</script>


<style scoped lang="scss">
html {
  box-sizing: border-box;
  font-family: "Open Sans", sans-serif;
}

*,
*:before,
*:after {
  box-sizing: inherit;
}

.background {
  padding: 0 15px 15px;
  position: relative;
  width: 100%;
}

.background::after {
  content: "";
  background: #60a9ff;
  background: -moz-linear-gradient(top, #60a9ff 0%, #4394f4 100%);
  background: -webkit-linear-gradient(top, #60a9ff 0%, #4394f4 100%);
  background: linear-gradient(to bottom, #60a9ff 0%, #4394f4 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#60a9ff', endColorstr='#4394f4',GradientType=0 );
  height: 350px;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 1;
}

@media (min-width: 900px) {
  .background {
    padding: 0 0 15px;
  }
}

.container {
  /* margin: 0 auto; */
  padding: 50px 50px 20px;
  padding-top: 50px;
  /* max-width: 960px; */
  width: 100%;
  max-height: 20%;
  /* width: 100%; */
}

.panel {
  background-color: #fff;
  border-radius: 15px;
  position: relative;
  width: 100%;
  /* z-index: 10; */
}

.pricing-table {
  box-shadow: 0px 10px 13px -6px rgba(0, 0, 0, 0.08),
    0px 10px 10px 3px rgba(0, 0, 0, 0.09), 0px 8px 10px 7px rgba(0, 0, 0, 0.02);
  display: flex;
  flex-direction: column;
}

@media (min-width: 900px) {
  .pricing-table {
    flex-direction: row;
  }
}

.pricing-table * {
  text-align: center;
  text-transform: uppercase;
}

.pricing-plan {
  border-bottom: 1px solid #e1f1ff;
  padding: 15px;
}

.pricing-plan:last-child {
  border-bottom: none;
}

@media (min-width: 900px) {
  .pricing-plan {
    border-bottom: none;
    border-right: 1px solid #e1f1ff;
    flex-basis: 100%;
    padding: 25px 50px;
  }

  .pricing-plan:last-child {
    border-right: none;
  }
}

.pricing-img {
  margin-bottom: 5px;
  max-width: 100%;
}

.pricing-header {
  color: #888;
  font-weight: 600;
  letter-spacing: 1px;
}

.pricing-features {
  color: #016ff9;
  font-weight: 600;
  letter-spacing: 1px;
  margin: 30px 0 25px;
}

.pricing-features-item {
  border-top: 1px solid #e1f1ff;
  font-size: 15px;
  line-height: 1.5;
  padding: 10px 0;
}

.pricing-features-item:last-child {
  border-bottom: 1px solid #e1f1ff;
}

.pricing-price {
  color: #016ff9;
  display: block;
  font-size: 22px;
  font-weight: 700;
  text-align: center;
}

.pricing-price-old {
  color: #888;
  text-decoration: line-through;
  margin-right: 8px;
  font-size: 18px;
  font-weight: 400;
  display: inline-block;
}

.pricing-price-new {
  color: #1cab5c;
  display: inline-block;
}

.pricing-button {
  border: 1px solid #9dd1ff;
  border-radius: 10px;
  color: #016ff9;
  display: inline-block;
  margin: 15px 0;
  padding: 15px 35px;
  text-decoration: none;
  transition: all 150ms ease-in-out;
}

.pricing-button:hover,
.pricing-button:focus {
  background-color: #e1f1ff;
}

.pricing-button.is-featured {
  background-color: #48aaff;
  color: #fff;
}

.pricing-button.is-featured:hover,
.pricing-button.is-featured:active {
  background-color: #269aff;
}
</style>
